<template>
  <div class="wg-row">
    <!-- Visualizzazione fattura -->
    <template v-if="invoiceData">
      <div class="wg-row">
        <button class="small" @click="invoiceData = null">
          <img :src="$anm22.icons.getWorldIcon('download')">
          <div>{{ $anm22.strLang(lang, 'Back', 'Indietro') }}</div>
        </button>
      </div>
      <div class="vertical-height-div" style="height:10px;"></div>
      <world-invoice-view
          :invoice="invoiceData.invoice"
          :lines="invoiceData.lines"
          :customerData="invoiceData.customerData"
          :work="invoiceData.work"
          :place="invoiceData.place"
          :printers="printers"
      ></world-invoice-view>
    </template>
    <!-- Creazione fattura -->
    <template v-else-if="payment">
      <div class="wg-row">
        <button class="small" @click="payment = null">
          <img :src="$anm22.icons.getWorldIcon('download')">
          <div>{{ $anm22.strLang(lang, 'Back', 'Indietro') }}</div>
        </button>
      </div>
      <div class="vertical-height-div" style="height:10px;"></div>
      <world-invoice-form 
          :hinting="true"
          @create-invoice="createInvoice"
      >
        <div slot="title">
          {{ $anm22.strLang(lang, 'Invoice for order ', 'Fattura ordine ') + order.number }}
        </div>
      </world-invoice-form>
    </template>
    <template v-else>
      <!-- Paga restante parte -->
      <div v-if="amountToPay > 0" class="wg-row payment-row">
        <div class="wg-col wg-xs-5 com-anm22-app-text-xl">
          {{ $anm22.strLang(lang, 'Remaining to pay', 'Rimanente da pagare')}}
        </div>
        <div class="wg-col wg-xs-3 com-anm22-app-text-xl">
          {{ amountToPay.toFixed(2) + ' €' }}
        </div>
        <div class="wg-col wg-xs-4" style="justify-content:end;">
          <button class="small" @click="pay">
            <!-- <img :src="$anm22.icons.getWorldIcon('list')"> -->
            <div>{{ $anm22.strLang(lang, 'Pay and create invoice', 'Paga e genera fattura') }}</div>
          </button>
        </div>
      </div>
      <!-- Lista pagamenti / fatture -->
      <div 
          class="wg-row payment-row"
          v-for="(p,i) in payments"
          :key="'payment-'+p.id"
      > 
        <div class="wg-col wg-xs-5 com-anm22-app-text-xl">
          {{ $anm22.strLang(lang, 'Payment #', 'Pagamento #') + (i+1) }}
        </div>
        <div class="wg-col wg-xs-3 com-anm22-app-text-xl">
          {{ p.payedTotal.toFixed(2) + ' €' }}
        </div>
        <div class="wg-col wg-xs-4">
          <button v-if="p.invoice" class="small" @click="openInvoice(p.invoice)">
            <!-- <img :src="$anm22.icons.getWorldIcon('list')"> -->
            <div>{{ $anm22.strLang(lang, 'View invoice', 'Visualizza fattura') }}</div>
          </button>
          <button v-else class="small" @click="payment = p">
            <!-- <img :src="$anm22.icons.getWorldIcon('list')"> -->
            <div>{{ $anm22.strLang(lang, 'Create invoice', 'Genera fattura') }}</div>
          </button>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import WorldInvoiceForm from '../../../../../world/spa/components/WorldInvoiceForm.vue';
import WorldInvoiceView from '../../../../../world/spa/components/WorldInvoiceView2.vue';

export default {
  components: {
    WorldInvoiceForm,
    WorldInvoiceView
  },
  props: {
    order: {
      type: Object,
      required: true
    },
    amountToPay: {
      type: Number,
      required: true
    },
    payments: {
      type: Array,
      required: true
    },
    // Prop di preselezione in caso di creazione o apertura rapida
    paymentId: {
      type: [Number, String],
      default: null
    },
    invoiceId: {
      type: [Number, String],
      default: null
    },
    printers: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      // Visualizzazione fattura già creata
      invoiceData: null,
      // Creazione fattura per pagamento
      payment: null
    }
  },
  computed: {
    ...mapState({
      lang: state => state.lang
    })
  },
  methods: {
    pay() {
      this.$emit('pay');
      // Successivamente viene settato l'id del pagamento così da aprire automaticamente la creazione della fattura
    },
    closeInvoiceModal() {
      this.payment = null;
      this.invoice = null;
    },
    async createInvoice(customerData) {
      try {
        const response = await this.$http.post('invoice', {
          paymentId: this.payment.id,
          customerData
        });
        if(response.data.success) {
          // Apertura fattura appena creata
          await this.$store.dispatch('foodPayments/update', {
            vlf: this.$vlf('foodPayments'), objs: response.data.payments
          });
          this.invoice = response.data.invoiceId;
          this.payment = null;
        }
      } catch(e) {
        console.log(e);
        // Messaggio di errore durante la creazione
      }
    },
    async openInvoice(id) {
      try {
        const response = await this.$http.get('invoice?invoiceId=' + id);
        if(!response.data.error) {
          this.invoiceData = response.data;
        }
      } catch(e) {
        console.log(e);
        // Messaggio di errore durante la creazione
      }
    }
  },
  created() {
    if(this.invoiceId) {
      this.openInvoice(this.invoiceId);
    } else if(this.paymentId) {
      this.payment = this.payments.find(p => p.id === this.paymentId);
    }
  },
  watch: {
    invoiceId(newVal) {
      this.payment = null;
      this.invoice = newVal;
    },
    paymentId(newVal) {
      this.invoice = null;
      this.payment = this.payments.find(p => p.id === this.paymentId);
    }
  }
}
</script>

<style lang="scss" scoped>
.payment-row {
  flex-wrap:nowrap;
  align-items:center;
  margin-bottom: 10px;
}
</style>
